import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  ServiceOutCreateServiceOut,
  ServiceOutFilterServiceOut,
  ServiceOutUpdateServiceOut,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";

function ServiceOutAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      if (id) {
        const ServiceOutFilterServiceOutData = await ServiceOutFilterServiceOut(
          {
            id: id,
          }
        );
        if (
          ServiceOutFilterServiceOutData.status &&
          ServiceOutFilterServiceOutData.status === 200
        ) {
          setForm(ServiceOutFilterServiceOutData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.address === "") {
      toast.error("Address را وارد نمایید ");
      validation = false;
    }
    if (form.userName === "") {
      toast.error("UserName را وارد نمایید ");
      validation = false;
    }
    if (form.password === "") {
      toast.error("Password را وارد نمایید ");
      validation = false;
    }
    if (form.token === "") {
      toast.error("Token را وارد نمایید ");
      validation = false;
    }
    if (form.isShair === "") {
      toast.error("IsShair را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const ServiceOutUpdateServiceOutData =
            await ServiceOutUpdateServiceOut(form);
          if (
            ServiceOutUpdateServiceOutData.status &&
            ServiceOutUpdateServiceOutData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/ServiceOut");
          }
        } else {
          const ServiceOutCreateServiceOutData =
            await ServiceOutCreateServiceOut(form);
          if (
            ServiceOutCreateServiceOutData.status &&
            ServiceOutCreateServiceOutData.status === 200
          ) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/ServiceOut");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <InputCus
                type="text"
                name="name"
                id="name"
                text="name"
                className="m-2"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="userName"
                id="userName"
                className="m-2"
                text="User Name"
                value={form.userName || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="pass"
                id="pass"
                className="m-2"
                text="pass"
                value={form.pass || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="token"
                id="token"
                className="m-2"
                text="Token"
                value={form.token || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="address"
                id="address"
                className="m-2"
                text="address"
                value={form.address || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="dataConection1"
                id="dataConection1"
                className="m-2"
                text="dataConection1"
                value={form.dataConection1 || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="dataConection2"
                id="dataConection2"
                className="m-2"
                text="dataConection2"
                value={form.dataConection2 || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="dataConection3"
                id="dataConection3"
                className="m-2"
                text="dataConection3"
                value={form.dataConection3 || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="dataConection4"
                id="dataConection4"
                className="m-2"
                text="dataConection4"
                value={form.dataConection4 || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="dataConection5"
                id="dataConection5"
                className="m-2"
                text="dataConection5"
                value={form.dataConection5 || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="dataConection6"
                id="dataConection6"
                className="m-2"
                text="dataConection6"
                value={form.dataConection6 || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceOutAE;
